var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_4432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5C9.57174 8.5 8.6815 8.86875 8.02513 9.52513C7.36875 10.1815 7 11.0717 7 12C7 12.9283 7.36875 13.8185 8.02513 14.4749C8.6815 15.1313 9.57174 15.5 10.5 15.5C11.02 15.5 11.53 15.38 12 15.16C12.47 15.38 12.98 15.5 13.5 15.5C14.4283 15.5 15.3185 15.1313 15.9749 14.4749C16.6313 13.8185 17 12.9283 17 12C17 11.0717 16.6313 10.1815 15.9749 9.52513C15.3185 8.86875 14.4283 8.5 13.5 8.5C12.98 8.5 12.47 8.62 12 8.84C11.53 8.62 11.02 8.5 10.5 8.5ZM10.5 9.5C10.67 9.5 10.835 9.515 11 9.55C10.36 10.205 10 11.085 10 12C10 12.915 10.36 13.795 11 14.445C10.835 14.48 10.67 14.5 10.5 14.5C9.83696 14.5 9.20107 14.2366 8.73223 13.7678C8.26339 13.2989 8 12.663 8 12C8 11.337 8.26339 10.7011 8.73223 10.2322C9.20107 9.76339 9.83696 9.5 10.5 9.5ZM13.5 9.5C14.163 9.5 14.7989 9.76339 15.2678 10.2322C15.7366 10.7011 16 11.337 16 12C16 12.663 15.7366 13.2989 15.2678 13.7678C14.7989 14.2366 14.163 14.5 13.5 14.5C13.33 14.5 13.165 14.485 13 14.45C13.64 13.795 14 12.915 14 12C14 11.085 13.64 10.205 13 9.555C13.165 9.52 13.33 9.5 13.5 9.5ZM12 10C12.63 10.475 13 11.215 13 12C13 12.785 12.63 13.525 12 14C11.37 13.525 11 12.785 11 12C11 11.215 11.37 10.475 12 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5C13 10.25 14.4 12.3 12 14.5C11 13.75 9.59997 11.7 12 9.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_4432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.0b40b429305d386bea4da359a22a9bd1.svg";
export { ForwardRef as ReactComponent };